import { Skeleton } from './Skeleton';
import { SkeletonRegion } from './SkeletonRegion';

interface RowListSkeletonProps {
  label: string;
  rows?: number;
}

/** Stacked bordered rows (a title and subline on the left, a tag or action on the right): collapse panels, document slots. */
export function RowListSkeleton({ label, rows = 3 }: RowListSkeletonProps) {
  return (
    <SkeletonRegion label={label} className="flex flex-col gap-3">
      {Array.from({ length: rows }, (_, row) => (
        <div key={row} className="flex items-center justify-between gap-3 rounded-lg border border-line bg-surface px-4 py-3.5">
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-3 w-28" />
          </div>
          <Skeleton className="h-6 w-20" />
        </div>
      ))}
    </SkeletonRegion>
  );
}
